module.exports = {"469002100":"嘉积镇","469002101":"万泉镇","469002102":"石壁镇","469002103":"中原镇","469002104":"博鳌镇","469002105":"阳江镇","469002106":"龙江镇","469002107":"潭门镇","469002108":"塔洋镇","469002109":"长坡镇","469002110":"大路镇","469002111":"会山镇","469002500":"彬村山华侨农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469002.json
// module id = 2197
// module chunks = 0